import { createApp } from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";

//imports for app initialization
import PrimeVue from "primevue/config";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";
import axios from "axios";
import VueAxios from "vue-axios";
import { globalCookiesConfig } from "vue3-cookies";

globalCookiesConfig({
  expireTimes: "30d",
  path: "/",
  domain: "",
  secure: true,
  sameSite: "None",
});

//imports for app style document
import "primevue/resources/themes/saga-blue/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";

import "@/core/plugins/prismjs";
import "@/assets/app.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap";
import "@/core/plugins/keenthemes";

//imports for app global component
import { ErrorMessage, Field, Form } from "vee-validate";
import DataTable from "primevue/datatable";
import InputText from "primevue/inputtext";
import Column from "primevue/column";
import TriStateCheckbox from "primevue/tristatecheckbox";
import MultiSelect from "primevue/multiselect";
import Dropdown from "primevue/dropdown";
import ToastService from "primevue/toastservice";
import Pagination from "@/components/global-components/Pagination.vue";
import BlockUI from "@/components/global-components/BlockUI.vue";
import SearchFilterInput from "@/components/global-components/SearchFilterInput.vue";
import ConfirmationService from "primevue/confirmationservice";
import ConfirmPopup from "primevue/confirmpopup";
import ConfirmDialog from "primevue/confirmdialog";
import Dialog from "primevue/dialog";

const app = createApp(App);
app.component("Dialog", Dialog);
app.component("ConfirmDialog", ConfirmDialog);
app.component("ConfirmPopup", ConfirmPopup);
app.component("FilterInput", SearchFilterInput);
app.component("Field", Field);
app.component("Form", Form);
app.component("ErrorMessage", ErrorMessage);
app.component("TriStateCheckbox", TriStateCheckbox);
app.component("Column", Column);
app.component("Dropdown", Dropdown);
app.component("MultiSelect", MultiSelect);
app.component("Pagination", Pagination);
app.component("InputText", InputText);
app.component("DataTable", DataTable);
app.component("BlockUI", BlockUI);
app.use(ConfirmationService);
app.use(ToastService);
app.use(store);
app.use(VueAxios, axios);
app.use(router);
app.use(ElementPlus);
app.use(PrimeVue);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

app.mount("#app");
